export default __webpack_public_path__ + "static/Header-0543bf0191218430e8f8224df88b44bc.png";